export default {
	namespaced: true,
	state: () => ({
		navVisible: false,
	}),
	mutations: {
		hideMobileNav(state) {
			state.navVisible = false;
		},
		showMobileNav(state) {
			state.navVisible = true;
		},
	},
	getters: {
		navVisible: (state) => state.navVisible,
	},
};
